import Vue from "vue";
import Router from "vue-router";
const login = () => import("@/views/login/login");
const Home = () => import("@/views/home/Home");
const HomeBlank = () => import("@/views/home/homeBlank");
const JobPublicity = () => import("@/views/jobPublicity/jobPublicity");
const ComplaintPublicity = () =>
  import("@/views/complaintPublicity/complaintPublicity");
const ComplaintList = () =>
  import("@/views/complaintPublicity/complaintList");
const ComplaintsReport = () =>
  import("@/views/complaintPublicity/complaintsReport");
  const ComplaintsDetails = () =>
  import("@/views/complaintPublicity/complaintsDetails");
const SchoolManagement = () =>
  import("@/views/schoolManagement/schoolManagement");
const RoleManagement = () => import("@/views/roleManagement/roleManagement");
const SubjectManagement = () =>
  import("@/views/subjectManagement/subjectManagement");
const Roles = () => import("@/views/authorityManagement/Roles");
const AccountManagement = () =>
  import("@/views/authorityManagement/AccountManagement");
const ClassManagement = () => import("@/views/classManagement/classManagement");
const Survey = () => import("@/views/survey/survey");
const JobStatistics = () => import("@/views/jobStatistics/jobStatistics");
const Feedback = () => import("@/views/feedback/feedback");
const PublishedJobAnalysis = () =>
  import("@/views/jobAnalysis/publishedJobAnalysis");
const AnalysisOfGrade = () => import("@/views/jobAnalysis/analysisOfGrade");
const AnalysisOfSubject = () => import("@/views/jobAnalysis/analysisOfSubject");
const GradeComparison = () => import("@/views/dataComparison/gradeComparison");
const ClassComparison = () => import("@/views/dataComparison/classComparison");
const SubjectComparison = () =>
  import("@/views/dataComparison/subjectComparison");
const DayWarning = () => import("@/views/dayWarning/dayWarning");
const AdministrationOfEducation = () =>
  import("@/views/informationMaintenance/administrationOfEducation");
const SchoolList = () => import("@/views/informationMaintenance/schoolList");
const StudentList = () => import("@/views/informationMaintenance/studentList");
const AdministrationOfSchool = () =>
  import("@/views/informationMaintenance/administrationOfSchool");
const AdministrationOfRole = () =>
  import("@/views/informationMaintenance/administrationOfRole");
// 成员管理
const MemberManagement = () =>
  import("@/views/classManagement/memberManagement");
// 用户管理
const roleManagementDetailS = () =>
  import("@/views/roleManagement/roleManagementDetailS");
const roleManagementDetailT = () =>
  import("@/views/roleManagement/roleManagementDetailT");

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [{
      path: "/login",
      name: "Login",
      component: login,
      meta: {
        title: "悠作业业务管理系统",
      },
    },
    {
      path: "/",
      name: "当前位置",
      component: HomeBlank,
      redirect: "/jobPublicitys",
      children: [{
          path: "/jobPublicity",
          name: "作业公示",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/jobPublicity/index")),
              "jobPublicity"
            ),
          redirect: "/jobPublicitys",
          meta: {
            title: "作业公示",
          },
          children: [
            {
              path: "/jobPublicitys/jobSchool",
              name: "作业公示学校列表",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobPublicity/jobSchool")),
                  "jobSchool"
                ),
              meta: {
                title: "作业公示学校列表",
              },
            },
            {
              path: "/jobPublicitys/jobGrade",
              name: "作业公示年级列表",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobPublicity/jobGrade")),
                  "jobGrade"
                ),
              meta: {
                title: "作业公示年级列表",
              },
            },
            {
              path: "/jobPublicitys/jobList",
              name: "作业公示作业列表",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobPublicity/jobList")),
                  "jobList"
                ),
              meta: {
                title: "作业公示作业列表",
              },
            },
            {
              path: "/jobPublicitys/jobDetail",
              name: "作业公示作业展示",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobPublicity/jobDetail")),
                  "jobDetail"
                ),
              meta: {
                title: "作业公示作业展示",
              },
            },
          ],
        },
        {
          path: "/jobPublicitys",
          name: "作业公示",
          component: JobPublicity,
          meta: {
            title: "作业公示",
          },
        },
        {
          path: "/complaintPublicity",
          name: "投诉公示",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/complaintPublicity/index")),
              "complaintPublicity"
            ),
          redirect: "/complaintPublicitys",
          meta: {
            title: "投诉公示",
          },
          children: [{
              path: "/complaintPublicitys/complaintList",
              name: "投诉列表",
              component: ComplaintList,
              meta: {
                title: "投诉列表",
              },
            },
            {
              path: "/complaintPublicitys/complaintsReport",
              name: "投诉举报",
              component: ComplaintsReport,
              meta: {
                title: "投诉举报",
              },
            },
            {
              path: "/complaintPublicitys/complaintsDetails",
              name: "投诉详情",
              component: ComplaintsDetails,
              meta: {
                title: "投诉详情",
              },
            },
          ],
        },
        {
          path: "/complaintPublicitys",
          name: "投诉公示",
          component: ComplaintPublicity,
          meta: {
            title: "投诉公示",
          },
        },
      ],
    },
    {
      path: "/home",
      name: "当前位置",
      component: Home,
      children: [
        //信息维护
        {
          path: "/administrationOfEducation",
          name: "信息维护",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/informationMaintenance/index")),
              "informationMaintenance"
            ),
          children: [
            //教育局管理
            {
              path: "/",
              name: "教育局管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/informationMaintenance/index")),
                  "informationMaintenance"
                ),
              meta: {
                title: "教育局管理",
              },
              redirect: "/administrationOfEducations",
              children: [{
                  path: "/administrationOfEducations/schoolList",
                  name: "学校列表",
                  component: SchoolList,
                  meta: {
                    title: "学校列表",
                  },
                },
                {
                  path: "/administrationOfEducations/studentList",
                  name: "用户列表",
                  component: StudentList,
                  meta: {
                    title: "用户列表",
                  },
                },
              ],
            },
            {
              path: "/administrationOfEducations",
              name: "教育局管理",
              component: AdministrationOfEducation,
              meta: {
                title: "教育局管理",
              },
            },
            //学校管理
            {
              path: "/administrationOfSchool",
              name: "学校管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/informationMaintenance/index")),
                  "administrationOfSchool"
                ),
              meta: {
                title: "学校管理",
              },
              redirect: "/administrationOfSchools",
              children: [],
            },
            {
              path: "/administrationOfSchools",
              name: "学校管理",
              component: AdministrationOfSchool,
              meta: {
                title: "学校管理",
              },
            },
            //用户管理
            {
              path: "/administrationOfRole",
              name: "用户管理",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/informationMaintenance/index")),
                  "administrationOfRole"
                ),
              meta: {
                title: "用户管理",
              },
              redirect: "/administrationOfRoles",
              children: [],
            },
            {
              path: "/administrationOfRoles",
              name: "用户管理",
              component: AdministrationOfRole,
              meta: {
                title: "用户管理",
              },
            },
          ],
        },
        //学校管理
        {
          path: "/schoolManagement",
          name: "学校管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/schoolManagement/index")),
              "schoolManagement"
            ),
          redirect: "/schoolManagements",
          meta: {
            title: "学校管理",
          },
          children: [],
        },
        {
          path: "/schoolManagements",
          name: "学校管理",
          component: SchoolManagement,
          meta: {
            title: "学校管理",
          },
        },
        //用户管理
        {
          path: "/roleManagement",
          name: "用户管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/roleManagement/index")),
              "roleManagement"
            ),
          redirect: "/roleManagements",
          meta: {
            title: "用户管理",
          },
          children: [],
        },
        {
          path: "/roleManagements",
          name: "用户管理",
          component: RoleManagement,
          meta: {
            title: "用户管理",
          },
        },
        // 用户管理家长编辑详情
        {
          path: "/roleManagementDetailS",
          name: "家长编辑详情",
          component: roleManagementDetailS,
          meta: {
            title: "家长编辑详情",
          },
        },
        // 用户管理教师编辑详情
        {
          path: "/roleManagementDetailT",
          name: "教师编辑详情",
          component: roleManagementDetailT,
          meta: {
            title: "教师编辑详情",
          },
        },
        //科目管理
        {
          path: "/subjectManagement",
          name: "科目管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/subjectManagement/index")),
              "subjectManagement"
            ),
          redirect: "/subjectManagements",
          meta: {
            title: "科目管理",
          },
          children: [],
        },
        {
          path: "/subjectManagements",
          name: "科目管理",
          component: SubjectManagement,
          meta: {
            title: "科目管理",
          },
        },
        //班级管理
        {
          path: "/classManagement",
          name: "班级管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/classManagement/index")),
              "classManagement"
            ),
          redirect: "/classManagements",
          meta: {
            title: "班级管理",
          },
          children: [],
        },
        {
          path: "/classManagements",
          name: "班级管理",
          component: ClassManagement,
          meta: {
            title: "班级管理",
          },
        },
        // 成员管理
        {
          path: "/memberManagement",
          name: "成员管理",
          component: MemberManagement,
          meta: {
            title: "成员管理",
          },
        },
        //权限管理
        {
          path: "/roles",
          name: "权限管理",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/authorityManagement/index")),
              "authorityManagement"
            ),
          meta: {
            title: "权限管理",
          },
          children: [{
              path: "/",
              name: "角色管理",
              component: Roles,
              meta: {
                title: "角色管理",
              },
            },
            {
              path: "/accountManagement",
              name: "账号管理",
              component: AccountManagement,
              meta: {
                title: "账号管理",
              },
            },
          ],
        },
        //概况
        {
          path: "/survey",
          name: "概况",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/survey/index")),
              "survey"
            ),
          redirect: "/surveys",
          meta: {
            title: "概况",
          },
          children: [],
        },
        {
          path: "/surveys",
          name: "概况",
          component: Survey,
          meta: {
            title: "概况",
          },
        },
        //作业统计
        {
          path: "/jobStatistics",
          name: "作业统计",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/jobStatistics/index")),
              "jobStatistics"
            ),
          redirect: "/jobStatisticss",
          meta: {
            title: "作业统计",
          },
          children: [],
        },
        {
          path: "/jobStatisticss",
          name: "作业统计",
          component: JobStatistics,
          meta: {
            title: "作业统计",
          },
        },
        //反馈问题
        {
          path: "/feedback",
          name: "反馈问题",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/feedback/index")),
              "feedback"
            ),
          redirect: "/feedbacks",
          meta: {
            title: "反馈问题",
          },
          children: [],
        },
        {
          path: "/feedbacks",
          name: "反馈问题",
          component: Feedback,
          meta: {
            title: "反馈问题",
          },
        },
        //作业分析
        {
          path: "/publishedJobAnalysis",
          name: "作业分析",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/jobAnalysis/index")),
              "jobAnalysis"
            ),
          children: [
            //发布作业分析
            {
              path: "/",
              name: "发布作业分析",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobAnalysis/index")),
                  "jobAnalysis"
                ),
              meta: {
                title: "发布作业分析",
              },
              redirect: "/publishedJobAnalysiss",
              children: [],
            },
            {
              path: "/publishedJobAnalysiss",
              name: "发布作业分析",
              component: PublishedJobAnalysis,
              meta: {
                title: "发布作业分析",
              },
            },
            //年级作业时长分析
            {
              path: "/analysisOfGrade",
              name: "年级作业时长分析",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobAnalysis/index")),
                  "analysisOfGrade"
                ),
              meta: {
                title: "年级作业时长分析",
              },
              redirect: "/analysisOfGrades",
              children: [],
            },
            {
              path: "/analysisOfGrades",
              name: "年级作业时长分析",
              component: AnalysisOfGrade,
              meta: {
                title: "年级作业时长分析",
              },
            },
            //学科作业时长分析
            {
              path: "/analysisOfSubject",
              name: "学科作业时长分析",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/jobAnalysis/index")),
                  "analysisOfGrade"
                ),
              meta: {
                title: "学科作业时长分析",
              },
              redirect: "/analysisOfSubjects",
              children: [],
            },
            {
              path: "/analysisOfSubjects",
              name: "学科作业时长分析",
              component: AnalysisOfSubject,
              meta: {
                title: "学科作业时长分析",
              },
            },
          ],
        },
        //数据对比
        {
          path: "/gradeComparison",
          name: "数据对比",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/dataComparison/index")),
              "dataComparison"
            ),
          children: [
            //年级时长对比
            {
              path: "/",
              name: "年级时长对比",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/dataComparison/index")),
                  "dataComparison"
                ),
              meta: {
                title: "年级时长对比",
              },
              redirect: "/gradeComparisons",
              children: [],
            },
            {
              path: "/gradeComparisons",
              name: "年级时长对比",
              component: GradeComparison,
              meta: {
                title: "年级时长对比",
              },
            },
            //班级时长分析
            {
              path: "/classComparison",
              name: "班级时长分析",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/dataComparison/index")),
                  "classComparison"
                ),
              meta: {
                title: "班级时长分析",
              },
              redirect: "/classComparisons",
              children: [],
            },
            {
              path: "/classComparisons",
              name: "班级时长分析",
              component: ClassComparison,
              meta: {
                title: "班级时长分析",
              },
            },
            //学科时长分析
            {
              path: "/subjectComparison",
              name: "学科时长分析",
              component: (r) =>
                require.ensure(
                  [],
                  () => r(require("@/views/dataComparison/index")),
                  "subjectComparison"
                ),
              meta: {
                title: "学科时长分析",
              },
              redirect: "/subjectComparisons",
              children: [],
            },
            {
              path: "/subjectComparisons",
              name: "学科时长分析",
              component: SubjectComparison,
              meta: {
                title: "学科时长分析",
              },
            },
          ],
        },
        //单日时长预警
        {
          path: "/dayWarning",
          name: "单日时长预警",
          component: (r) =>
            require.ensure(
              [],
              () => r(require("@/views/dayWarning/index")),
              "dayWarning"
            ),
          redirect: "/dayWarnings",
          meta: {
            title: "单日时长预警",
          },
          children: [],
        },
        {
          path: "/dayWarnings",
          name: "单日时长预警",
          component: DayWarning,
          meta: {
            title: "单日时长预警",
          },
        },
      ],
    },
  ],
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js